import { TableCell, TableRow, Typography } from '@mui/material';
import SvgIconStyle from 'components/SvgIconStyle';
import { renderRowCreatedAt } from 'utils/renderTableCell';
import { themesMockData } from 'mocks/themesMockData';
import { useMemo, useState } from 'react';
import { RejectHistory } from 'components/dialog/RejectHistory';

export const EditRequestsTableRow = ({ row, index }) => {
  const [openRejectHistory, setOpenRejectHistory] = useState(false);
  const { site, siteConfig } = row || {};

  const selectedTheme = useMemo(() => {
    if (siteConfig && siteConfig.theme) {
      return themesMockData.filter((x) => x.value === siteConfig.theme)[0].title;
    }
    return '';
  }, [siteConfig]);

  return (
    <>
      <TableRow key={index} hover>
        <TableCell align="left">
          <Typography>{index + 1}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{site?.title || 'عنوان نامشخص'}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{renderRowCreatedAt('fa-IR', site?.createdAt)}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{site?.userID}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{siteConfig?.support?.phones?.map((p) => p)}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{selectedTheme || 'نامشخص'}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{site?.type === 1 ? 'فروشگاهی' : site?.type === 2 ? 'شخصی' : '---'}</Typography>
        </TableCell>
        <TableCell align="left">
          <a
            href={`https://${site?.status !== 4 ? site?.host : site?.host.split('!')[2]}.aff.bizmlm.ir`}
            target="_blank"
            rel="noreferrer"
          >
            <Typography>{site?.status !== 4 ? site?.host : site?.host.split('!')[2]}</Typography>
          </a>
        </TableCell>
        {/* <TableCell align="left">
          <Typography color={renderStatusColor(site?.status)}>{renderStatusName(site?.status)}</Typography>
        </TableCell> */}
        {/* <TableCell align="left">
          {[3, 4].includes(site?.status) ? (
            <Button
              variant="contained"
              color={site?.status === 3 ? 'success' : 'error'}
              onClick={() => setOpenRejectHistory(true)}
            >
              مشاهده
            </Button>
          ) : (
            '-'
          )} */}
        {/* </TableCell> */}
        <TableCell align="left" sx={{ display: 'flex' }}>
          <div
            aria-hidden
            onClick={
              () =>
                window?.open(
                  `/dashboard/request/${site?.type === 1 ? 'update/' : ''}${site?.type === 1 ? 'detail' : 'cvDetail'}/${
                    site?._id
                  }?update=1`,
                  // : `/dashboard/request/detail/${site?._id}`,
                  '_blank'
                )
              // window?.open(
              //   `/dashboard/request/${site?.type}`,
              //   '_blank'
              // )
            }
          >
            <SvgIconStyle src="/icons/send_icon.svg" sx={{ width: 20, height: 20, cursor: 'pointer' }} />
          </div>
          <div style={{ margin: '0px 10px' }}>
            <SvgIconStyle src="/icons/dots.svg" sx={{ width: 20, height: 20, cursor: 'pointer' }} />
          </div>
        </TableCell>
      </TableRow>
      <RejectHistory
        open={openRejectHistory}
        onClose={() => setOpenRejectHistory(false)}
        content={site?.status === 3 ? row?.activation : row?.deactivation}
        status={site?.status}
      />
    </>
  );
};
